import { render, staticRenderFns } from "./GSMCard.vue?vue&type=template&id=42d7344f&scoped=true"
import script from "./GSMCard.vue?vue&type=script&lang=js"
export * from "./GSMCard.vue?vue&type=script&lang=js"
import style0 from "./GSMCard.scss?vue&type=style&index=0&id=42d7344f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7344f",
  null
  
)

export default component.exports